import {unique} from './unique';

export const appendUnique = <T extends string | number>(
  orig: T[] | undefined,
  append: T[] | undefined,
): T[] => {
  return unique<T>((orig ?? [])?.concat(append ?? []));
};
